export const tro12DataEn = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "@id": "https://www.wm.com/us/en/dumpster-rental/12-yard",
      url: "https://www.wm.com/us/en/dumpster-rental/12-yard",
      name: "12 Yard Dumpster Rental | WM",
      primaryImageOfPage: {
        "@id": "https://www.wm.com/us/en/dumpster-rental/12-yard/#primaryimage",
      },
      image: {
        "@id": "https://www.wm.com/us/en/dumpster-rental/12-yard/#primaryimage",
      },
      thumbnailUrl:
        "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/12-yard/12-yd-header.jpg",
      description:
        "Our 12 yard dumpster rentals are ideal for disposing of heavy materials and debris from small residential construction projects. Schedule your rental online today.",
    },
    {
      "@type": "ImageObject",
      inLanguage: "en-US",
      "@id": "https://www.wm.com/us/en/dumpster-rental/12-yard/#primaryimage",
      url: "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/12-yard/12-yd-header.jpg",
      contentUrl:
        "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/12-yard/12-yd-header.jpg",
      width: 545,
      height: 327,
      caption: "12 yard dumpster dimensions",
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://www.wm.com/us/en/dumpster-rental/12-yard/#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.wm.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Dumpster Rental",
          item: "https://www.wm.com/us/en/dumpster-rental",
        },
        { "@type": "ListItem", position: 3, name: "12-Yard" },
      ],
    },
  ],
}

export const tro12ProductDataEn = {
  "@context": "https://schema.org",
  "@type": "Product",
  "@id": "https://www.wm.com/us/en/dumpster-rental/12-yard/#product",
  name: "12 Yard Dumpster Rental | WM",
  image:
    "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/12-yard/12-yd-header.jpg",
  description:
    "One of our smaller sizes, the 12 yard dumpster is a convenient option for heavy materials, concrete, asphalt, and other moderate disposal needs. Whether you’re remodeling a room or clearing out an attic, our dumpster rentals are easy to schedule online and manage delivery and pickup.",
  url: "https://www.wm.com/us/en/dumpster-rental/12-yard",
  mainEntityOfPage: "https://www.wm.com/us/en/dumpster-rental/12-yard",
  isRelatedTo: [
    "10 Yard Dumpster",
    "15 Yard Dumpster",
    "20 Yard Dumpster",
    "30 Yard Dumpster",
    "40 Yard Dumpster",
  ],
  brand: { "@type": "Brand", "@id": "https://www.wm.com/#brand" },
}
